import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AnalyticsPage from "./pages/AnalyticsPage";
import GEXDEXPage from "./components/GEXDEXPage"; // ✅ FIXED PATH
import InstallPrompt from "./components/InstallPrompt";

function App() {
  return (
    <BrowserRouter>

      <InstallPrompt />
      <Routes>

Get-ChildItem .\src\components -File | Select-Object Name        {/* ✅ Default route */}
        <Route path="/" element={<Navigate to="/nifty" />} />

        {/* ✅ Static routes first */}
        <Route path="/compare" element={<AnalyticsPage />} />
        <Route path="/gex-dex" element={<GEXDEXPage />} />

        {/* ✅ Dynamic route LAST (important) */}
        <Route path="/:index" element={<AnalyticsPage />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;